import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const T = styled(Typography)(() => ({ marginTop: '15px' }));

export const P = ({children}) => <Typography component="span" color="primary">{children}</Typography>;
